import React, { useState } from 'react';
import { Load, ModalDevolucion } from './partials/PopUps';
import TotalSucursales from './Dashboard/TotalSucursales';
import Autocomplete from './Dashboard/Autocomplete';
// import VentasDelDiaCajero from './Dashboard/TablaVenta';
import { toast } from 'react-toastify';
import PrintTicket from './Dashboard/PrintTicket';
import TipoDePago from './Dashboard/TipoDePago';

function ItemsProduct(props){
	let producto = props.producto;
	let [clase, setClase] = useState(true);
	producto.total = producto.precio * producto.cantidad;
	const cantidad = ({currentTarget : { value : val }}) => {
		if( ( Number(val) <= Number(producto.existencias) ) === true ){
			producto.cantidad = val;
			producto.total = producto.precio * producto.cantidad;
			setClase(true);
			setTimeout(()=>props.getTotal(),200);
		}else{
			setClase(false);
			const message = producto.devolucion === 2 ?
			'No puedes devolver más productos de los que compraste originalmente' :
			'No se puede agregar más productos de los que hay en existencia' ;
			toast.warning(message);
		}
	}
	return (
		<tr>
			<td className="xcodigo">{producto.codigo}</td>
			<td className="xproducto">{producto.nombre}</td>
			<td className="xprecio">${producto.precio}</td>
			<td className="xexistencia">
				<input
					type='number'
					min='1'
					className={ clase ? 'number' : 'number error' }
					max={producto.existencias}
					onChange={cantidad}
					value={producto.cantidad}
				/>
			</td>
			<td>{ window.$fmoney(producto.total,2)}</td>
			<td>{ producto.devolucion === 2 ? 'Si' : 'No' }</td>
			<td className="operaciones">
				<span className="icon-trash" onClick={(e)=>props.trash(producto.id)}></span>
			</td>
		</tr>
	)
}
const ItemDiv = ({name, value, clase = ''}) =>{
	return 	(
		<div className={`item ${clase}`}>
			<div className="xs-12 sm-12 md-12 lg-6 no-padding">
				{name}:
			</div>
			<div className="xs-12 sm-12 md-12 lg-6 no-padding">
				<strong>{value}</strong>
			</div>
		</div>
	)
}
class Dashboard extends React.Component {
	constructor(props){
		super(props);
		this.state = { 
			productos : [],
			descuento : {id:0,porcentaje:0,cantidad:0},
			namesProduct : [],
			sucursales : [],
			car : [],
			carDevolucion : {},
			subtotal : 0,
			pagoCon : 0,
			cambio : 0,
			total : 0,
			reloj : new Date(),
			fecha : null,
			cantidad : 0,
			btnLocked : false,
			display : { load : false },
			printTicket : false,
			is_show_load : false,
			is_show_message : false,
			transaccion : 'Venta',
			ventaid : 0,
			buscarVenta : false,
			folioVenta : '',
			elTicket : [],
			codigoDeBusqueda : '',
			resurtir : 0,
			formaDePago: 1,
			clearInput:false,
			countEfectivo:0,
			countTarjeta:0,
			totalCaja:0,
			gastos:0,
			showTipoDePago:false
		}
		this.fetchProds();
	}
	componentDidMount() {
		let self = this;
		let scannedBarcode="";
		document.onkeydown = e => {
			if (e.key !== "Enter" ) {
				scannedBarcode += e.key;
			}
			if (e.key === "Enter" ) {
				scannedBarcode = scannedBarcode.replace("'","-");
				scannedBarcode = scannedBarcode.trim();
				self.addforCodeCart(scannedBarcode);
				scannedBarcode = '';
			}
		};
	}
	componentWillUnmount() {
		window.onkeydown = null;
		this.setState = () => false;
	}
	addforCodeCart = codigo => {
		this.setState({clearInput: false});
		codigo = codigo.trim();
		if( codigo !== 'Backspace' ){
			let _car = [];
			let producto = this.state.productos.find(e=>e.codigo===codigo);
			let car = this.newObject(this.state.car);
			let _producto = car.find(p=>p.codigo===codigo);
			if( _producto === undefined && producto !== undefined ){
				car.push(producto);
			}else{
				_car = car.map(p=>{
					if(p.codigo===codigo){
						p.cantidad++;
					}
					return p;
				});
				car = _car;
			}
			this.setState({car});
			setTimeout( ()=>{ this.getTotal() },200);
		}
	}
	newObject = obj => JSON.parse( JSON.stringify( obj ) );
	carEmpty = () => Object.entries(this.state.car).length > 0;
	closeModalPrint = () => this.setState({printTicket : ! this.state.printTicket });
	getHour = () => {
		let fecha = new Date();
		return fecha.getHours()+':'+fecha.getMinutes()+':'+fecha.getSeconds();
	}
	fetchProds = () => {
		let fecha = new Date();
		let month = fecha.getMonth() + Number(1);
		month = month < 10 ? '0'+month : month;
		const today = fecha.getFullYear()+'-'+month+'-'+fecha.getDate();
		fecha = fecha.getDate()+'/'+month+'/'+fecha.getFullYear();
		const sesion = JSON.parse(localStorage.getItem('sesion'));
		
		fetch(window.$api+'/getInfoDashboard/'+today+'_'+sesion.sucursal+'_'+sesion.id)
		.then(res=>res.json())
		.then(
			data=>{
				let namesProduct=[];
				let precio_p = 0;
				const gastos = window.$fmoney( data.gastos, 2 );
				const sucursales = data.sucursales;
				const descuentos = data.descuentos;
				let productos = [];
				if( sesion.rol > 1){
					productos = data.productos?.map(e=>{
						precio_p = window.$fmoney(e['precio'],2);
						namesProduct.push(e['codigo']+' / '+e['nombre']+' / '+precio_p+' / '+e['cantidad']);
						e['existencias'] = parseInt(e['cantidad']);
						e['cantidad'] = 1;
						e['total'] = 0;
						return e;
					});
				}

				let countEfectivo=0, countTarjeta=0, totalCaja=0;
				if( data.total ){
					data.total.forEach(item=>{
						totalCaja = totalCaja + parseFloat(item.total)
						console.log(item.formaDePago)
						if( item.formaDePago === "1" || item.formaDePago === 1 ){
							countEfectivo++;

						}else{
							countTarjeta++;
						}
					})
				}
				totalCaja = window.$fmoney(totalCaja, 2)
				this.setState({
					productos, fecha, sucursales, descuentos, namesProduct,
					countEfectivo, countTarjeta, totalCaja, gastos
				});
			},
			error=>{console.log(error)}
		);
	}
	trash = (productoid) => {
		const car = this.state.car.filter(e=>e.id !== productoid);
		if( car.length > 0 ){
			this.setState({car});
			setTimeout(()=>{this.getTotal()},300);
		}else{
			const car = [], pagoCon = 0, cambio = 0, subtotal = 0, total = 0;
			this.setState({car, pagoCon, cambio, subtotal, total});
		}
	}
	handlerTransaccion = e => {
		const transaccion = e.target.value;
		const car = [], total = 0, subtotal = 0, descuento = {}, pagoCon = 0;
		let buscarVenta = false;
		if( transaccion === 'Cambio' ){
			buscarVenta = true;
		}
		this.setState({transaccion, car, buscarVenta, total, subtotal, descuento, pagoCon });
	}
	handlerFolioVenta = e =>{
		let folioVenta = e.target.value;
		let regex = new RegExp("^[a-zA-Z ]+$");
		folioVenta = regex.test(folioVenta) ? "" : folioVenta;
		this.setState({folioVenta});
	}
	closeModalDevolucion = e => {
		const buscarVenta = false;
		const carDevolucion = {};
		const folioVenta = "";
		const transaccion = this.state.car.length > 0 ? "Cambio" : "Venta";
		this.setState({transaccion, folioVenta, buscarVenta, carDevolucion });
	}
	devolucion = e => {
		const folio = this.state.folioVenta;
		if( folio ){
			this.setState({ display : { load : true } });
			fetch(window.$api+'/getVenta/'+folio)
			.then(res=>res.json())
			.then(
				data=>{
					const carrito = data.carrito.map(p=>{
						p.existencias = p.cantidad;
						return p;
					})
					if( Object.keys(carrito).length > 0 ){
						this.setState({
							car : carrito, 
							ventaid : data.venta.id,
							transaccion : 'Cambio',
							display : { load : false } 
						});
						this.closeModalDevolucion();
						setTimeout(()=>this.getTotal(),200);
					}
				},
				error=>{
					this.setState({ display : { load : false } });
					toast.error("No se encontró la venta");
				}
			);
		}else{
			toast.warning("Capture el folio para realizar la búsqueda");
		}
	}
	total_menos_descuento = () => {
		let total = 0;
		const subtotal = this.state.subtotal;
		let descuento = this.state.descuentos.find(e=>subtotal>=Number(e.cantidad));
		if( descuento !== undefined ){
			total = subtotal - ( ( Number(descuento.porcentaje) * subtotal ) / 100 );
		}else{
			total = subtotal;
		}
		this.setState({total,descuento});
	}
	getTotal = () => {
		let subtotal = 0, subtotalVenta = 0, subtotalCambio = 0, total = 0;
		let carrito = this.state.car;
		carrito.forEach(e=>{
			e.total = ( e.cantidad * e.precio ).toFixed(2);
			if( e.devolucion === 2 ){ //si
				subtotalCambio = subtotalCambio + Number( e.total );
			}else{
				subtotalVenta = subtotalVenta + Number( e.total );
			}
		});
		subtotal = subtotalVenta - subtotalCambio;
		let btnLocked = false;
		if( subtotalVenta === subtotalCambio && this.state.transaccion === 'Cambio' ){
			btnLocked = true;
		}
		total = subtotal;
		let pagoCon = 0, cambio = 0;
		this.setState({subtotal, total, pagoCon, cambio, btnLocked});
		if( this.state.transaccion === 'Venta' ){
			this.total_menos_descuento();
		}
	}
	getCode = nombre => {
		return nombre.split(' / ')[0].trim();
	}
	addCart = nombre => {
		this.setState({clearInput: false});
		if( nombre ){
			const codigo = this.getCode(nombre);
			let car = this.newObject(this.state.car);
			let producto = car.find(p=>p.codigo===codigo);
			if(producto === undefined){
				producto = this.state.productos.find(p=>p.codigo===codigo);
				if( producto.existencias > 0 ){
					producto.devolucion = 1;
					car.push(producto);
					this.setState({car});
					setTimeout(()=>{this.getTotal()},300);
				}else{
					toast.warning("Producto agotado");
				}
			}
		}
	}

	capturarCambio = e => {
		let pagoCon = e.target.value;
		let _pagoCon = Number(pagoCon).toFixed(2);
		const total = Number(this.state.total.toFixed(2));
		let cambio = _pagoCon - total;
		let btnLocked = false;
		if( total > 0 ){
			cambio.toFixed(2);
			if( _pagoCon >= total ){
				btnLocked = true;
			} 
			this.setState({cambio, btnLocked,pagoCon});
		}else{
			cambio = total >= 0 ? cambio : 0;
			this.setState({cambio, pagoCon});
		}
	}
	
	closeConfirm1 = () => {
		toast.warning("Agregue elementos a la venta");
	}

	cobrar = () => {
		
		this.setState(e=>{
			const display = { load : ! e.display.load };
			return{
				display
			}
		});	
		if( this.state.car.length > 0 ){
			const sesion = JSON.parse(localStorage.getItem('sesion'));
			const elTicket = {
				car : this.state.car,
				vendedor : sesion.name,
				descuento : ( this.state.descuento ? this.state.descuento.porcentaje : 0 ),
				verndedor_id : Number(sesion.id),
				sucursal_id : Number(sesion.sucursal),
				fecha : this.state.fecha,
				hora : this.getHour(),
				transaccion : this.state.transaccion,
				subtotal : this.state.subtotal.toFixed(2),
				cambio : this.state.cambio.toFixed(2),
				total : this.state.total.toFixed(2),
				paga_con : this.state.pagoCon,
				ventaid : this.state.ventaid,
				formaDePago : 1,//this.state.formaDePago
			}
			const config = { 
				method : 'POST',
				headers : {'Content-Type': 'application/json'},
				body : JSON.stringify(elTicket)
			};
			
			fetch( window.$api+'/ventas', config)
			.then(res=>res.json()).then(
				venta =>{
					const display = { load : ! this.state.display.load };
					
					const car = [];
					const printTicket = ! this.state.printTicket;
					const cantidad = 0;
					const subtotal = 0;
					const pagoCon = 0;
					const cambio = 0;
					const total = 0;
					const transaccion = 'Venta';
					const descuento =false;
					const btnLocked = !this.state.btnLocked;
					
					let elTicket = {
						venta :  venta.venta,
						car : venta.car,
						totales : venta.totales,
						caja : venta.caja
					}
					

					const resurtir = venta.totales;
					const clearInput = true;
					this.setState({
						display, elTicket, car,
						printTicket,cantidad, subtotal, pagoCon, total, cambio,
						transaccion, btnLocked, descuento, resurtir, clearInput
					});
					this.fetchProds();
				},
				error=>{
					const display = !this.state.display;
					this.setState({display});
				}
			);
		}
	}
	// tipoPago = () => {
	// 	const show = this.state.showTipoDePago;
	// 	this.setState({showTipoDePago: !show})
	// }
	// setFormaPago = (value) =>{
	// 	this.setState({formaDePago:value})
	// 	setTimeout(()=>{
	// 		this.setState({showTipoDePago: false})
	// 		this.cobrar();
	// 	},500)
	// }
	render(){

		let sesion = JSON.parse( localStorage.getItem('sesion') );
		let items=[];
		if( this.state.car.length > 0 ){
			this.state.car.forEach((e,index)=>{
				items.push(	
					<ItemsProduct
						key={index}
						trash={this.trash} 
						producto={e}
						cambio={this.state.transaccion}
						getTotal={this.getTotal}
					/>
				)
			})
		}
		const clase = this.state.descuento && this.state.descuento.porcentaje ? ' success-area' : ' disabled-area'
		return(
			<div className="wrap-module">
				<div className="wrap-content">
					<div className="xs-12 sm-12 md-8 lg-9">

						{ (sesion.rol !== 1 && this.state.productos.length > 0) &&
							<div>
								<div className="xs-12 sm-12 md-12 lg-12">
									<Autocomplete 
										suggestions={this.state.namesProduct}
										car={this.state.car}
										select={this.addCart}
										clear={this.state.clearInput}
									/><br/>
								</div>
							</div>
						}
						{ ( sesion.rol > 1 && this.state.productos.length === 0 ) && 
							<div className="square-pink">
								<span>No se han cargado productos para esta sucursal</span>
							</div>
						}
					<div>
					</div>
						{ sesion.rol !== 1 && 
						<div className="bodyTable">
							<table className="table-dash table-dash border-single radius-top margin-none">
								<thead>
									<tr>
										<th className="th">Código</th>
										<th className="th">Producto</th>
										<th className="th">Precio</th>
										<th className="th cantidad">Cantidad</th>
										<th className="th">Subtotal</th>
										<th className="th">Cambio</th>
										<th className="th">Acción</th>
									</tr>
								</thead>
								<tbody id="bodyReport">
									{items}
									<tr>
										<td></td><td></td>
										<td></td>
										<td></td><td></td>
										<td></td><td></td>
									</tr>
								</tbody>
							</table>
						</div>
						}
						{ sesion.rol !== 1 && <>
							<div style={{marginTop:'-8px'}}>
								<table className="table-dash radius-bottom">
									<tfoot>
										<tr>
											<td colSpan="3" className="text-right">
												<strong>Productos </strong>
											</td>
											<td>
												<strong>
													{this.state.cantidad}&nbsp;
												</strong>
											</td>
											<td colSpan="2">
												<strong>
													{
													this.state.subtotal>=0?window.$fmoney(this.state.subtotal,2):'-$'+this.state.subtotal.toFixed(2)
													}
												</strong>
											</td>
										</tr>
									</tfoot>
								</table>
							</div>
							<br></br>
						<div className="xs-12 sm-12 md-12 lg-12 no-padding">
							{/* <div className="xs-3 sm-3 md-3 lg-3" style={{'color':'transparent'}}>&nbps; */}
								{/* <label>Venta en efectivo: {this.state.countEfectivo}</label> */}
							{/* </div>
							<div className="xs-3 sm-3 md-3 lg-3" style={{'color':'transparent'}}>&nbps; */}
								{/* <label>Venta con Tarjeta: {this.state.countTarjeta}</label> */}
							{/* </div>
							<div className="xs-3 sm-3 md-3 lg-3"> */}
								<label>Total caja: {this.state.totalCaja}</label>
							{/* </div>
							<div className="xs-3 sm-3 md-3 lg-3"> */}
								{/* <label>Gastos: {this.state.gastos}</label> */}
							{/* </div> */}
						</div>
							</>
						}
						
					</div>
					{ sesion.rol !== 1 && 
						<div className="xs-12 sm-12 md-4 lg-3">
							<div className="square-white side">
								<ItemDiv name={"Vendedor"} value={<span className='text-pink' style={{fontSize:'14px'}}>{sesion.name}</span>}/>
								<ItemDiv name={"Fecha"} value={<span style={{fontSize:'14px'}}>{this.state.fecha}</span>}/>
								<div className="item">
									<div className="xs-12 sm-12 md-12 lg-6 no-padding">
										Transacción:
									</div>
									<div className="xs-12 sm-12 md-12 lg-6 no-padding">
										<select 
											name="transaccion" 
											value={this.state.transaccion}
											onChange={this.handlerTransaccion}
										>
											<option value="Venta">Venta</option>
											<option value="Cambio">Cambio</option>
										</select>
									</div>
								</div>
								<ItemDiv 
									name={"Subtotal"} 
									value={ this.state.subtotal>=0?
										window.$fmoney(this.state.subtotal,2):
										<strong style={{color:'#f55'}}>-{window.$fmoney(this.state.subtotal,2)}</strong>
									}
								/>
								
								<div className="item">
									<div className="xs-12 sm-12 md-12 lg-6 no-padding">
										Pago con:
									</div>
									<div className="xs-12 sm-12 md-12 lg-6 no-padding">
										<input type="number" className="text inpNumber" min='0' onChange={this.capturarCambio} value={this.state.pagoCon||''}/> 
									</div>
								</div>
								<ItemDiv name={"Cambio"} value={this.state.cambio<0?0:window.$fmoney(this.state.cambio,2)}/>
								<ItemDiv name={"Descuento"} value={`${ this.state.descuento?.porcentaje ? this.state.descuento.porcentaje : 0 }%`} clase={clase}/>
								
								<div className="item">
									<div className="xs-12 sm-12 md-12 lg-12"><br/>
										<div className={this.state.total < 0 ? "square-pink error" : "square-pink"}>
											<span>Total</span>
											<h3>{ this.state.total < 0 ? '-'+window.$fmoney(this.state.total,2) : window.$fmoney(this.state.total,2) }</h3>
										</div>
									</div>

									<div className="xs-12 sm-12 md-12 lg-12 text-center"><br/>
										{ this.state.btnLocked ? 
											<div className="btn btn-green pagar" onClick={this.cobrar}>COBRAR</div>
											: <div className="btn btn-locked">COBRAR</div> }
									</div>
								</div>
							</div>
						</div>
					}
					
					{
						(sesion.rol===1&&this.state.sucursales.length>0)
						?
						<TotalSucursales sucursales={this.state.sucursales} rol={sesion.rol} getInfo={this.getInfoSucursal}/>
						:''
					}
					
				</div>
				<div className={ this.state.resurtir > 5000 ? "square-yellow show" : "square-yellow"}>
                  <div>
                     <span>La sucursal {sesion.sucursal_name}, llegó a un total de ventas de: <b>{ window.$fmoney(this.state.resurtir,2) } MXN</b>, <br/>revise los reportes para surtir mercancia</span>
                     <div className="close" onClick={()=>{ 
						this.setState({ resurtir : 0 }); 
                     }}>Enterado</div>
                  </div>
				</div>
				{
					this.state.printTicket === true && 
					<PrintTicket 
						print={this.state.printTicket}
						is_show_message = {this.is_show_message}
						is_show_load = {this.is_show_load}
						closeModalPrint={this.closeModalPrint}
						elTicket={this.state.elTicket}
					/>
				}
				{
					this.state.buscarVenta === true && 
					<ModalDevolucion 
						folio={this.state.folioVenta}
						display={this.state.buscarVenta} 
						handler={this.handlerFolioVenta}
						close={this.closeModalDevolucion}
						devolucion={this.devolucion}
						select={this.select}
						
					/>
				}
				<Load display={this.state.display.load} />
				<TipoDePago 
					show={this.state.showTipoDePago} 
					tipoPago={this.tipoPago}
					setFormaPago={this.setFormaPago}/>
			</div>
		)
	}
}
export default Dashboard;
